import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translation } from '../../../../utils/helpers'
// Actions
import { getBufferTimeDistribution, saveBufferTimeDistribution } from '../../../../actions/settings'

// Components
import DecimalInput from '../../../../shared/components/DecimalInput'
import LabelWrapper from '../../../../shared/elements/labelWrapper'
import Grid from '../../../../shared/elements/grid'

import { transformPercent } from '../../../../utils/percent'

const ProcessTimeDamagetype = {
  RepairDamage: 0,
  InstallationDamage: 1
}

class BufferTimeDistribution extends Component {
  constructor (props) {
    super(props)
    this.gridCols = '1fr 96px 96px' // [ 1, 1, 1 ]
    this.state = {
      BufferTimeDistributionResponse: {
        BufferTimeDistributions: [],
        MessagesKey: 0
      },

      BufferTimeDistributionInfo: {
        BufferTimeDistributionId: 0,
        CompanyId: 0,
        BeforePaint: null,
        AfterPaint: null,
        Damagetype: 0
      }
    }

    this.onBlur = this.onBlur.bind(this)
  }

  componentDidMount () {
    this.renderBufferTimeDistribution()
  }

  renderBufferTimeDistribution () {
    this.props.getBufferTimeDistribution().then((res) => {
      console.log('res', res)
      this.setState({
        BufferTimeDistributionResponse: res.data
      })
    }, (error) => {
      console.log(error)
    })
  }

  onBlur () {
    const BufferTimeDistributionInfo = this.state.BufferTimeDistributionInfo
    if (BufferTimeDistributionInfo) {
      this.props.saveBufferTimeDistribution(BufferTimeDistributionInfo).then((res) => {
        console.log('res', res)
        if (res.data.MessagesKey === 0) {
          // window.toastr.success(translation('18088'), translation('13424'))
        } else {
          window.toastr.error(translation('18085'), translation('216'))
        }
        this.setState({
          BufferTimeDistributionResponse: res.data
        })
      }, (error) => {
        console.log(error)
      })
    }
  }

  getDamageTypeName (typeNme) {
    switch (typeNme) {
      case ProcessTimeDamagetype.RepairDamage:
        return translation('14828') // Repair damage
      case ProcessTimeDamagetype.InstallationDamage:
        return translation('14784') // Installation damage
    }
  }

  transformValue (value, toClean) {
    return transformPercent(value, toClean)
  }
  render () {
    let { BufferTimeDistributions } = this.state.BufferTimeDistributionResponse
    const renderBufferTime = (val, key) => {
      const onChange = (e) => {
        let editedBuffer = this.state.BufferTimeDistributionResponse.BufferTimeDistributions
        if (e.target.value !== '') {
          let value = parseInt(e.target.value)
          if (value > 99999999) value = 99999999
          editedBuffer[key][e.target.name] = value
        } else {
          editedBuffer[key][e.target.name] = ''
        }
        this.setState({
          BufferTimeDistributionInfo: {
            ...this.state.BufferTimeDistributionInfo,
            BufferTimeDistributionId: editedBuffer[key].BufferTimeDistributionId,
            CompanyId: editedBuffer[key].CompanyId,
            [e.target.name]: e.target.value,
            Damagetype: editedBuffer[key].Damagetype
          }
        })
      }

      const size = 'm'
      let damageType = this.getDamageTypeName(val.Damagetype)

      return (
        <Grid cols={this.gridCols} rowSpan='3' align='center' key={key}>
          <div>{damageType}</div>
          <DecimalInput name='BeforePaint' value={val.BeforePaint} onChange={onChange} onBlur={this.onBlur} decimals={0} transformValue={this.transformValue} size={size} />
          <DecimalInput name='AfterPaint' value={val.AfterPaint} onChange={onChange} onBlur={this.onBlur} decimals={0} transformValue={this.transformValue} size={size} />
        </Grid>
      )
    }

    return (
      <div>
        <Grid cols={this.gridCols} align='center'>
          <LabelWrapper labelText={translation('16478')} />
          <LabelWrapper labelText={translation('18087')} helpText={translation('18092')} />
          <LabelWrapper labelText={translation('18089')} helpText={translation('18093')} />
        </Grid>
        {BufferTimeDistributions && BufferTimeDistributions.map(renderBufferTime)}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getBufferTimeDistribution,
  saveBufferTimeDistribution
})(BufferTimeDistribution)



// WEBPACK FOOTER //
// ./src/app/pages/Settings/Process/BufferTimeDistribution/index.js